// extracted by mini-css-extract-plugin
export var indicator = "styles-module__indicator___dDXSL";
export var container = "styles-module__container___qffoo";
export var seoPage = "styles-module__seoPage___NWka9";
export var open = "styles-module__open___OJZ7y";
export var invert = "styles-module__invert___BmskV";